import React, { FC } from 'react';

const HelpIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.1666 7.99967C14.1666 11.4054 11.4057 14.1663 7.99992 14.1663C4.59416 14.1663 1.83325 11.4054 1.83325 7.99967C1.83325 4.59392 4.59416 1.83301 7.99992 1.83301C11.4057 1.83301 14.1666 4.59392 14.1666 7.99967Z"
      stroke="#2555FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7.99967V5.33301"
      stroke="#2555FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.667H8.00667"
      stroke="#2555FE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HelpIcon;
